import React, {Component} from 'react'
import {Col, Row} from "reactstrap";
import {Input, message, Modal} from "antd";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";


class AboutUsModal extends Component {
    state = {
        password: '',
        confirmPassword: '',
        isResetting: false
    }

    render() {
        const { onClose } = this.props
        return(
            <div>
                <Modal
                    onCancel={onClose}
                    onOk={onClose}
                    visible={true}
                    title="Kapstone Identity Intelligent Certification UI"
                >
                    <div>
                        <Row>
                            <Col md={12} sm={12} xs={12}>
                                <form className="form">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Version: {this.props.version}</span>
                                    </div>
                                </form>
                            </Col>
                        </Row>
                    </div>
                </Modal>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    version: (state && state.local && state.local.Version) || "",
});

export default connect(mapStateToProps, null) (withRouter(AboutUsModal));